module.exports = __webpack_public_path__ + "img/pnu_detail.9fa9ddb5.jpg";